import { combineReducers } from 'redux';

import sourceReducer from 'services/source/reducer';
import { Enclave } from 'shared/types/enclave';

import { ENRICH_ENCLAVES_WITH_METADATA } from './actions';
import { EnclaveAction } from './types';

const enclaveListReducer = (state: Enclave[] = [], action: EnclaveAction) => {
  switch (action.type) {
    case ENRICH_ENCLAVES_WITH_METADATA:
      const { enclaves, enclaveMetadata } = action.payload;
      const enrichedEnclaves: Enclave[] = [];

      enclaves.forEach((enclave) => {
        const metadata = enclaveMetadata.find(({ enclaveGuid }) => enclaveGuid === enclave.id);

        enrichedEnclaves.push({
          ...enclave,
          lastSubmitted: metadata?.lastPulled,
          subscribed: metadata?.created,
        });
      });

      return enrichedEnclaves;
    default:
      return state;
  }
};

export default combineReducers({
  list: enclaveListReducer,
  // As sources are actually enclaves, I decided to combine the source-related reducers in the
  // enclave reducer.
  source: sourceReducer,
});
